import { render } from "./ProdutoNovaVariacao.vue?vue&type=template&id=54ffe226&scoped=true&ts=true"
import script from "./ProdutoNovaVariacao.vue?vue&type=script&lang=ts"
export * from "./ProdutoNovaVariacao.vue?vue&type=script&lang=ts"

import "./ProdutoNovaVariacao.vue?vue&type=style&index=0&id=54ffe226&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ffe226"]])

export default __exports__